<template lang="pug">
  div(class='webrtc_container')
    video(class='webrtc_video' ref='video' autoplay muted playsinline controls)
    div(v-if='error' class='webrtc_error') {{ error }}
</template>

<script>
import mixin from "../mixins";

// Live ВК 3.0 раздаётся по WHEP: плеер отправляет на ссылку потока SDP-предложение,
// сервер отвечает своим описанием, и дальше видео идёт напрямую через RTCPeerConnection.
const waitIceGathering = (pc) => new Promise((resolve) => {
  if (pc.iceGatheringState === "complete") return resolve();

  const onChange = () => {
    if (pc.iceGatheringState !== "complete") return;
    pc.removeEventListener("icegatheringstatechange", onChange);
    resolve();
  };
  pc.addEventListener("icegatheringstatechange", onChange);
});

export default {
  name: "PlayerWebRtc",
  mixins: [mixin],
  data() {
    return {
      error: null,
    };
  },
  beforeDestroy() {
    this.closeConnection();
  },
  methods: {
    initPlayer(signature) {
      this.closeConnection();
      this.error = null;

      const pc = new RTCPeerConnection({ iceServers: [] });
      this.player = pc;

      pc.addTransceiver("video", { direction: "recvonly" });
      pc.addTransceiver("audio", { direction: "recvonly" });
      pc.ontrack = (event) => {
        this.$refs.video.srcObject = event.streams[0];
      };
      pc.oniceconnectionstatechange = () => {
        if (pc.iceConnectionState === "failed") {
          this.error = "Не удалось установить соединение с сервером потока";
        }
      };

      pc.createOffer()
        .then((offer) => pc.setLocalDescription(offer))
        .then(() => waitIceGathering(pc))
        .then(() => fetch(`${this.url}?${signature}`, {
          method: "POST",
          headers: { "Content-Type": "application/sdp" },
          body: pc.localDescription.sdp,
        }))
        .then((response) => {
          if (!response.ok) throw new Error(`Сервер потока ответил ${response.status}`);
          return response.text();
        })
        .then((sdp) => {
          // Пока ждали ответ, диалог могли закрыть или открыть другой поток.
          if (this.player !== pc) return;
          return pc.setRemoteDescription({ type: "answer", sdp });
        })
        .catch((e) => {
          if (this.player !== pc) return;
          this.error = e instanceof TypeError
            ? "Не удалось подключиться к серверу потока"
            : e.message;
        });
    },
    closeConnection() {
      if (!this.player) return;

      this.player.close();
      this.player = null;
    },
  },
};
</script>

<style scoped>
.webrtc_container {
  position: relative;
  width: 100%;
  height: 400px;
}

.webrtc_video {
  width: 100%;
  height: 100%;
  background-color: #424242;
}

.webrtc_error {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  text-align: center;
  color: #fff;
}
</style>
